import React, { useCallback, useState } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import * as constants from '../../constants';

const Context = React.createContext();

export const RSAMenuSettingsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const [selectedRSAMenuSettingsTab, setSelectedRSAMenuSettings] = useState(constants.INSTANCE_TYPE.Corporate);

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `RSAMenuSettings/GetRSAMenuPreferences/${props.instanceTypeId}`, method: 'GET', secure: true });
    }, [execute]);

    const setRSAMenuPreference = useCallback(async (props) => {
        await execute({ scope: 'update', url: `RSAMenuSettings/SetRSAMenuPreference?menuId=${props.menuId}&instanceTypeId=${props.instanceTypeId}&isEnabled=${props.isEnabled}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const value = {
        data, selectedRSAMenuSettingsTab, setSelectedRSAMenuSettings, listRecords, clearData, setRSAMenuPreference
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useRSAMenuSettingsStore = () => React.useContext(Context);
